import { SocietyAiPlanTier } from 'types/Society';
import { AiQuotaExceededModalContextType } from '../types/AiQuotaExceededModalContextType';

export const aiQuotaExceededModalInitValue: AiQuotaExceededModalContextType = {
  data: {
    used: 0,
    limit: 0,
    tier: SocietyAiPlanTier.FREE,
  },
  actions: {
    handleCloseModal: () => {},
    handleUpgrade: () => {},
  },
};
